import get from 'lodash/get';
import { createSelector } from 'reselect';

import { appealSubmitIdentityDocumentSelector } from '../passport/selectors';
import { appealSubmitPersonSelector } from '../mainData/selectors';
import { appealSubmitParticipantSelector } from '../gia/selectors';
import { currentExamSelector, getDateTime } from '../examData/selectors';
import { formNotCorrectExamSelector } from './selectors';
import { appealSubmitIdentityDocumentSelector as appealSubmitIdentityDocumentChildSelector } from '../passportChild/selectors';
import { appealSubmitPersonSelector as appealSubmitPersonChildSelector } from '../mainDataChild/selectors';
import { appealSubmitActRecordSelector } from '../actRecord/selectors';
import { getConvertedExamType } from '../serializers/exam';

const subjectSelector = createSelector(
  currentExamSelector,
  formNotCorrectExamSelector,
  (currentExam, formNotCorrectExam) => ({
    subject_name: get(currentExam, 'subject_name'),
    subject_code: parseInt(get(currentExam, 'subject_code'), 10),
    file_url: currentExam.file,
    exam_type: getConvertedExamType(currentExam),
    exam_date: currentExam.date,
    email_form_incorrect: formNotCorrectExam.email.value,
    phone_form_incorrect: formNotCorrectExam.phone.value,
    comment: formNotCorrectExam.comment.value,
    protocol: {
      protocol_num: currentExam.protocol_number,
      protocol_date: getDateTime(currentExam.protocol_date)
    }
  })
);

export const notCorrectExamStructuredSelector = createSelector(
  subjectSelector,
  appealSubmitIdentityDocumentSelector,
  appealSubmitParticipantSelector,
  appealSubmitPersonSelector,
  appealSubmitActRecordSelector,
  /* eslint-disable camelcase */
  (subject, document, participant, declarant, gia_participant) => {
    const private_persons = [
      {
        type: 'DECLARANT',
        ...declarant,
        documents: [document]
      }
    ];

    return {
      contacts: {
        private_persons
      },
      properties: {
        subject,
        participant,
        gia_participant,
        applicant_consent: true
      }
    };
  }
  /* eslint-enable camelcase */
);

export const notCorrectExamStructuredParentSelector = createSelector(
  subjectSelector,
  appealSubmitIdentityDocumentSelector,
  appealSubmitParticipantSelector,
  appealSubmitPersonSelector,
  appealSubmitIdentityDocumentChildSelector,
  appealSubmitPersonChildSelector,
  appealSubmitActRecordSelector,
  /* eslint-disable camelcase */
  (
    subject,
    document,
    participant,
    declarant,
    child_document,
    child,
    gia_participant
  ) => {
    const private_persons = [
      {
        type: child ? 'LEGAL_REPRESENTATIVE' : 'DECLARANT',
        ...declarant,
        documents: [document]
      }
    ];

    if (child) {
      private_persons.push({
        type: 'DECLARANT',
        ...child,
        documents: [child_document]
      });
    }

    return {
      contacts: {
        private_persons
      },
      properties: {
        subject,
        participant,
        gia_participant,
        applicant_consent: true
      }
    };
  }
  /* eslint-enable camelcase */
);
